import {Account, AccountType} from '../models/accounts/account.model';
import {JobType} from '../models/pos/jobType.model';

export namespace Accounts {
  export class GetAccounts {
    static readonly type = '[Accounts api] Get Accounts';

    constructor(public type: AccountType, public force: boolean = false) {
    }
  }

  export class GetAccount {
    static readonly type = '[Accounts api] Get Account';

    constructor(public id: string, public force: boolean = false) {
    }
  }

  export class GetAccountOrders {
    static readonly type = '[Accounts api] Get Account Orders';

    constructor(public id: string, public force: boolean = false) {
    }
  }

  export class UpdateAccount {
    static readonly type = '[Accounts api] Update Account';

    constructor(public account: Account) {
    }
  }

  export class CreateAccount {
    static readonly type = '[Accounts api] Create Account';

    constructor(public account: Account) {
    }
  }

  export class DeleteAccount {
    static readonly type = '[Accounts api] Delete Account';

    constructor(public account: Account) {
    }
  }

  export class UpdateJobDebtor {
    static readonly type = '[Accounts api] Update Job Debtor';

    constructor(public accountId: string, public type: JobType) {
    }
  }
}

